import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
const CanonicalUrlContext = /*#__PURE__*/createContext('');
function CanonicalUrlProvider({
  children,
  canonicalUrl = ''
}) {
  return /*#__PURE__*/jsx(CanonicalUrlContext.Provider, {
    value: canonicalUrl,
    children: children
  });
}
const useCanonicalUrl = () => useContext(CanonicalUrlContext);
export { CanonicalUrlProvider, useCanonicalUrl };
//# sourceMappingURL=CanonicalUrlProvider.js.map
